import type { IconProps } from './../../models/icon';

export function GiftIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          fillRule="evenodd"
          d="M2.57122 5.14288H21.4284C22.3752 5.14288 23.1426 5.9104 23.1426 6.85717V12C23.1426 12.9468 22.3752 13.7143 21.4284 13.7143V21.4286C21.4284 21.8832 21.2477 22.3193 20.9262 22.6408C20.6048 22.9622 20.1687 23.1429 19.7141 23.1429H4.28551C3.83084 23.1429 3.39481 22.9622 3.07332 22.6408C2.75184 22.3193 2.57122 21.8832 2.57122 21.4286V13.7143C1.62445 13.7143 0.856934 12.9468 0.856934 12V6.85717C0.856934 5.9104 1.62445 5.14288 2.57122 5.14288Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M21.4284 5.14288H2.57122C1.62445 5.14288 0.856934 5.9104 0.856934 6.85717V12C0.856934 12.9468 1.62445 13.7143 2.57122 13.7143H21.4284C22.3752 13.7143 23.1426 12.9468 23.1426 12V6.85717C23.1426 5.9104 22.3752 5.14288 21.4284 5.14288Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M21.4284 13.7143V21.4286C21.4284 21.8832 21.2477 22.3193 20.9263 22.6408C20.6049 22.9622 20.1688 23.1429 19.7141 23.1429H4.28557C3.83091 23.1429 3.39488 22.9622 3.07339 22.6408C2.75191 22.3193 2.57129 21.8832 2.57129 21.4286V13.7143"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 5.14288V23.1429"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M17.1426 0.857117L11.9998 5.14283L6.85693 0.857117"
        />
      </g>
    </svg>
  );
}
